import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'premiereLettreMajusculePipe'
})
export class PremiereLettreMajusculePipeMock implements PipeTransform {

	transform(value: any): any {
		return value;
	}

}
